export default __webpack_public_path__ + "static/media/field_of_study_search.adbc2fce.svg";